import { useMemo } from 'react';
import { computeColumns, type Column } from '../lib/columns';
import { getKnownReleases } from '../lib/release-detect';
import { useConfig } from '../store/config';
import { useData } from '../store/data';
import { useFilters } from '../store/filters';
import { useModel } from './useModel';

// Eine Säulen-Berechnung pro Block (Release oder Team). Memoisiert über
// alle Eingaben, sodass nur bei echter Änderung neu gerechnet wird.
//
// teamOverride: lokaler Team-Filter, der den globalen Filter aus useFilters
// überschreibt — wird vom Funnel und anderen Komponenten genutzt, die einen
// eigenen Team-Selector im Header haben.
export function useColumns(
  blockName: string,
  blockReleaseFilter = '',
  teamOverride?: string,
): Column[] {
  const rows = useData(s => s.rows);
  const model = useModel();
  const releaseCal     = useConfig(s => s.releaseCal);
  const capacityByTeam = useConfig(s => s.capacityByTeam);
  const initialPlan    = useConfig(s => s.initialPlan);
  const spToPtFactor   = useFilters(s => s.spToPtFactor);
  const globalTeam     = useFilters(s => s.team);
  const teamFilter     = teamOverride !== undefined ? teamOverride : globalTeam;

  return useMemo(() => {
    const knownReleases = getKnownReleases(Object.keys(releaseCal));
    return computeColumns({
      blockName,
      rows,
      model,
      knownReleases,
      capacityByTeam,
      initialPlan,
      spToPtFactor,
      groupMode: 'release', // Phase 2.5: nur Release-Blöcke
      teamFilter,
      blockReleaseFilter,
      releaseCal,
    });
  }, [blockName, blockReleaseFilter, rows, model, releaseCal, capacityByTeam, initialPlan, spToPtFactor, teamFilter]);
}
